import { Grid } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import AppSummarySearchBar from '@/common/components/form-inputs/AppSummarySearchBar';
import AppMultipleDropDownMenu from '@/common/components/form-inputs/AppMultipleDropDownMenu';
import { APPROACH_SOURCE_LIST } from '@/common/constants/common';
import { PreAdmissionFilter } from '@/api/DTO/pre-admission/preAdmission.interface';
import { useGetStaffAllListQuery } from '@/api/common';
import { selectMyInfo } from '@/pages/auth/authSlice';
import { useSelector } from 'react-redux';

interface Props {}
export default function PreAdmissionSummaryFilterSection(props: Props) {
	const { t } = useTranslation();
	const { control } = useFormContext<PreAdmissionFilter>();
	const userInfo = useSelector(selectMyInfo);

	const { data: details }: any = useGetStaffAllListQuery(
		userInfo?.currentBranch?.id || '',
		{
			refetchOnMountOrArgChange: true,
			skip: !userInfo?.currentBranch,
		}
	);

	return (
		<Grid container rowSpacing={2} columnSpacing={1}>
			<Grid size={2.5}>
				<AppSummarySearchBar
					name='searchString'
					control={control}
					placeholder={t('common.search')}
				/>
			</Grid>
			<Grid size={2}>
				<AppMultipleDropDownMenu
					control={control}
					name='approachSourceList'
					label={t('preAdmission.approachAource')}
					options={APPROACH_SOURCE_LIST}
					emptyArrayIfNoSelection
				/>
			</Grid>
			<Grid size={2}>
				<AppMultipleDropDownMenu
					control={control}
					name='createdByList'
					label={t('preAdmission.creator')}
					options={details?.data || []}
					emptyArrayIfNoSelection
				/>
			</Grid>
		</Grid>
	);
}
